<template>
    <div>
        <h1 style="font-size: 24px; color: black;">APP广告ID配置</h1>
        <el-row>
            <el-col>
                <el-button type="primary" @click="showSaveFormDialog('新增应用')">新增应用</el-button>
            </el-col>
        </el-row>
        <el-col :span="10">
            <span>渠道</span>
            <el-select v-model="queryData.channels" placeholder="请选择" multiple filterable>
                <el-option
                    v-for="item in subChannels"
                    :key="item.channel"
                    :label="item.remark"
                    :value="item.channel">
                </el-option>
            </el-select>
            <span>app应用</span>
            <el-select v-model="queryData.appIds" placeholder="请选择" multiple filterable>
                <el-option
                    v-for="item in apps"
                    :key="item.appId"
                    :label="item.appName"
                    :value="item.appId">
                </el-option>
            </el-select>
        </el-col>
        <el-button type="primary" @click="getList">查询</el-button>
        <h1>
            <el-table border :data="list">
                <el-table-column prop="id" label="编号" align="center"></el-table-column>
                <el-table-column prop="appId" label="应用" align="center" :formatter="appFormatter"></el-table-column>
                <!-- 渠道格式化 -->
                <el-table-column prop="channels" label="渠道" align="center" :formatter="channelFormatter"></el-table-column>
                <!-- 新增 是否生效 -->
                <el-table-column prop="deleted" label="是否生效" align="center" :formatter="statusFormatter"></el-table-column>
                <el-table-column prop="remark" label="备注" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showSaveFormDialog('编辑配置',scope.row.id)">编辑</el-button>
                        <el-button type="text" @click="remove(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </h1>

        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="1200px">
            <el-form :model="saveBase">
                <el-form-item label="应用名称" :label-width="labelWidth" >
                    <el-select v-model="saveBase.appId" filterable>
                        <el-option
                            v-for="item in apps"
                            :key="item.appId"
                            :label="item.appName"
                            :value="item.appId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="渠道" :label-width="labelWidth">
                    <el-select v-model="saveBase.channels" placeholder="请选择" multiple filterable>
                        <el-option
                            v-for="item in subChannels"
                            :key="item.channel"
                            :label="item.remark"
                            :value="item.channel">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" :label-width="labelWidth">
                    <el-input v-model="saveBase.remark"></el-input>
                </el-form-item>
                <el-form-item label="大于等于版本号" :label-width="labelWidth">
                    <el-input v-model="saveBase.versionCode"></el-input>
                </el-form-item>
                <el-form-item label="是否可用：" :label-width="labelWidth">
                    <el-switch v-model="saveBase.deleted"
                               :active-value="false"
                               :inactive-value="true"
                               active-text="开启"
                               inactive-text="关闭">
                    </el-switch>
                </el-form-item>
            </el-form>

            <div style="margin:10px 0;">
                <el-button type="success" @click="addDetailGroup">+ 添加一组广告配置</el-button>
            </div>

            <div
                v-for="(item, index) in detailList"
                :key="index"
                style="border:1px solid #E4E7ED; padding:15px; margin-bottom:15px; border-radius:5px;">
                <div style="display: flex; justify-content: space-between; margin-bottom:10px;">
                    <span>第 {{ index + 1 }} 组广告配置</span>
                    <el-button type="danger" size="mini" @click="deleteDetailGroup(index)">删除本组</el-button>
                </div>

                <el-form :model="item" :label-width="labelWidth">
                    <el-form-item label="组别"><el-input v-model="item.ab"></el-input></el-form-item>
                    <el-form-item label="比例 每个都填10以上 和并不一定非得是100"><el-input v-model="item.rate"></el-input></el-form-item>
                    <el-form-item label="冷启开屏"><el-input v-model="item.splashPostId"></el-input></el-form-item>
                    <el-form-item label="热启开屏"><el-input v-model="item.hotSplashPostId"></el-input></el-form-item>
                    <el-form-item label="首页插屏"><el-input v-model="item.InsertAdIndex"></el-input></el-form-item>
                    <el-form-item label="新用户首次插屏"><el-input v-model="item.InsertAdNewUser"></el-input></el-form-item>
                    <el-form-item label="插屏-身高"><el-input v-model="item.InsertAdMeasure"></el-input></el-form-item>
                    <el-form-item label="插屏-养成"><el-input v-model="item.InsertAdCat"></el-input></el-form-item>
                    <el-form-item label="插屏-小游戏"><el-input v-model="item.InsertAdGame"></el-input></el-form-item>
                    <el-form-item label="激励视频-新三个礼盒场景"><el-input v-model="item.infoPostId"></el-input></el-form-item>
                    <el-form-item label="激励视频-窗台猫"><el-input v-model="item.chuangtaiPostId"></el-input></el-form-item>
                    <el-form-item label="激励视频-其他"><el-input v-model="item.yangchengqitaPostId"></el-input></el-form-item>
                    <el-form-item label="激励视频-气球&招财猫"><el-input v-model="item.qizhaoPostId"></el-input></el-form-item>
                    <el-form-item label="激励视频-商城"><el-input v-model="item.shangchengPostId"></el-input></el-form-item>
                    <el-form-item label="激励视频-洗澡&撸猫"><el-input v-model="item.xiluPostId"></el-input></el-form-item>
                    <el-form-item label="激励视频-小游戏"><el-input v-model="item.rewardGame"></el-input></el-form-item>
                    <el-form-item label="激励视频-幸运转盘"><el-input v-model="item.zhuanpanPostId"></el-input></el-form-item>
                    <el-form-item label="激励视频-衣柜&家具试用"><el-input v-model="item.yijiaPostId"></el-input></el-form-item>
                    <el-form-item label="激励视频-游历"><el-input v-model="item.youliPostId"></el-input></el-form-item>
                    <el-form-item label="虚假用户激励视频"><el-input v-model="item.fakeRewardPostId"></el-input></el-form-item>
                    <el-form-item label="激励视频_养成（新）"><el-input v-model="item.yangchengNewPostId"></el-input></el-form-item>
                    <el-form-item label="插屏_养成（新）"><el-input v-model="item.insertAdCatNewPostId"></el-input></el-form-item>
                </el-form>
            </div>

            <div style="text-align: center;">
                <el-button type="primary" @click="confirmForm">提 交</el-button>
                <el-button type="info" @click="dialogVisible=false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {appAll} from '@/http/api'
import {adDetails, adList, kittyChannelList, saveAdId,removeAdId} from "../../http/iosApi";

export default {
    name: "AdAb",
    data() {
        return {
            dialogVisible: false,
            dialogTitle: '',
            labelWidth: '160px',
            list: [],
            subChannels: [],
            apps: [],
            saveBase: {},
            detailList: [],
            queryData: {},
            originalBase: null
        }
    },
    methods: {
        getOriginalDetail() {
            return {
                ab: null,
                rate: null,
                splashPostId: null,
                hotSplashPostId: null,
                InsertAdIndex: null,
                InsertAdNewUser: null,
                InsertAdMeasure: null,
                InsertAdCat: null,
                InsertAdGame: null,
                infoPostId: null,
                chuangtaiPostId: null,
                yangchengqitaPostId: null,
                qizhaoPostId: null,
                shangchengPostId: null,
                xiluPostId: null,
                rewardGame: null,
                zhuanpanPostId: null,
                yijiaPostId: null,
                youliPostId: null,
                fakeRewardPostId: null,
                yangchengNewPostId: null,
                insertAdCatNewPostId: null,
            }
        },
        addDetailGroup() {
            this.detailList.push(this.getOriginalDetail())
        },
        deleteDetailGroup(index) {
            this.detailList.splice(index, 1)
        },
        // 应用名称格式化
        appFormatter(row, column, cellValue) {
            let temp = ""
            this.apps.forEach(item => {
                if (item.appId === cellValue) temp = item.appName
            })
            return temp
        },
        // 渠道格式化  code => 中文备注
        channelFormatter(row, column, cellValue) {
            if(!cellValue) return ''
            const codeArr = cellValue.split(',')
            const nameArr = []
            codeArr.forEach(code => {
                const find = this.subChannels.find(c => c.channel === code)
                if(find) nameArr.push(find.remark)
            })
            return nameArr.join('、')
        },
        // 是否生效格式化
        statusFormatter(row, column, cellValue) {
            return cellValue === false ? '开启' : '关闭'
        },
        getList() {
            adList(this.queryData).then(resp => {
                this.list = resp.data.info.list
            })
        },
        remove(rowId) {
            this.$confirm('删除？', '提示', {type: 'warning'}).then(() => {
                removeAdId({ id: rowId }).then(() => {
                    this.$message.success('删除成功');
                    this.getList();
                })
            }).catch(() => {
            })
        },

        async showSaveFormDialog(title, id) {
            this.dialogTitle = title;
            this.saveBase = {
                id: null, appId: null, channels: [], remark: null, versionCode: null, deleted: false
            };
            this.detailList = [this.getOriginalDetail()];
            this.originalBase = null;
            this.dialogVisible = true;

            if (!id) return;

            let res = await adDetails({id: id});
            const data = res.data.info;

            this.originalBase = data.base;

            this.saveBase.id = data.base.id;
            this.saveBase.appId = data.base.appId;
            this.saveBase.remark = data.base.remark;
            this.saveBase.versionCode = data.base.versionCode;
            this.saveBase.deleted = data.base.deleted;

            // 修复：接口返回小写字段，映射到页面大写字段
            this.detailList = (data.list || []).map(item => ({
                ab: item.ab,
                rate: item.rate,
                splashPostId: item.splashPostId,
                hotSplashPostId: item.hotSplashPostId,
                InsertAdIndex: item.InsertAdIndex,
                InsertAdNewUser: item.InsertAdNewUser,
                InsertAdMeasure: item.InsertAdMeasure,
                InsertAdCat: item.InsertAdCat,
                InsertAdGame: item.InsertAdGame,
                infoPostId: item.infoPostId,
                chuangtaiPostId: item.chuangtaiPostId,
                yangchengqitaPostId: item.yangchengqitaPostId,
                qizhaoPostId: item.qizhaoPostId,
                shangchengPostId: item.shangchengPostId,
                xiluPostId: item.xiluPostId,
                rewardGame: item.rewardGame,
                zhuanpanPostId: item.zhuanpanPostId,
                yijiaPostId: item.yijiaPostId,
                youliPostId: item.youliPostId,
                fakeRewardPostId: item.fakeRewardPostId,
                yangchengNewPostId: item.yangchengNewPostId,
                insertAdCatNewPostId: item.insertAdCatNewPostId,
            }));

            const channelStr = data.base.channels || '';
            this.saveBase.channels = channelStr.split(',');
        },

        confirmForm() {
            if (!this.saveBase.channels.length) return this.$message.error('渠道必选');
            if (!this.saveBase.appId) return this.$message.error('应用必选');
            if (!this.saveBase.remark) return this.$message.error('备注必填');

            const submitData = {
                base: {
                    ...this.originalBase,
                    ...this.saveBase,
                    channels: this.saveBase.channels.join(',')
                },
                detailList: this.detailList
            };

            saveAdId(submitData).then(res => {
                if (res.data.status === 0) {
                    this.$message.success('保存成功');
                    this.getList();
                    this.dialogVisible = false;
                }
            });
        }
    },
    created() {
        this.getList();
        appAll().then(res => this.apps = res.data.info);
        kittyChannelList().then(res => this.subChannels = res.data.info);
    }
}
</script>

<style scoped>
</style>